// CANONICAL AIROTECH build tiers (general product-development/build service).
// machine value (stable) + display label + investment range + definition + scope.
export const LEVELS = [
  {
    value: "starter",
    name: "Starter",
    price: "$400–$800",
    definition: "Simple websites, landing pages, and single-purpose tools.",
    examples: ["Landing pages", "Simple informational websites", "Microsites", "Simple calculators", "Simple forms", "Single-purpose tools"],
  },
  {
    value: "standard",
    name: "Standard",
    price: "$1,500–$4,000",
    definition: "Small apps with basic user accounts and a handful of core features.",
    examples: ["Small web applications", "Basic authenticated apps", "Basic dashboards", "Small PWAs", "Apps with a database", "A limited number of core workflows"],
  },
  {
    value: "mvp_pro",
    name: "MVP Pro",
    price: "$5,000–$12,000",
    featured: true,
    definition: "Full multi-user products with integrations, payments, or admin functionality.",
    examples: ["Multi-user SaaS products", "Roles & permissions", "Payment-enabled products", "Significant integrations", "Administrative functionality", "More sophisticated AI/automation"],
  },
  {
    value: "custom",
    name: "Custom",
    price: "Human Review",
    isCustom: true,
    definition: "Complex or unusual requirements outside the standard build levels.",
    examples: ["Complex enterprise systems", "Unusual technical architecture", "Highly specialized integrations", "Complex multi-system environments", "Significant unknowns"],
  },
];
